import Table, {TableProps} from '@mui/material/Table';
import TableBody, {TableBodyProps} from '@mui/material/TableBody';
import TableCell, {TableCellProps} from '@mui/material/TableCell';
import TableHead, {TableHeadProps} from '@mui/material/TableHead';
import TableRow, {TableRowProps} from '@mui/material/TableRow';
import TableContainer, {TableContainerProps} from '@mui/material/TableContainer';
import TableFooter, {TableFooterProps} from '@mui/material/TableFooter';
import TablePagination, {TablePaginationProps} from '@mui/material/TablePagination';
import TableSortLabel, {TableSortLabelProps} from '@mui/material/TableSortLabel';

import {styled} from '@mui/material/styles';

export const CTable = styled(Table)<TableProps>(
  (/* { theme } */) => ({
  }),
);

export const CTableBody = styled(TableBody)<TableBodyProps>(
  (/* { theme } */) => ({
  }),
);


export const CTableCell = styled(TableCell)<TableCellProps>(
  (/* { theme } */) => ({
  }),
);


export const CTableHead = styled(TableHead)<TableHeadProps>(
  (/* { theme } */) => ({
  }),
);


export const CTableRow = styled(TableRow)<TableRowProps>(
  (/* { theme } */) => ({
  }),
);


export const CTableContainer = styled(TableContainer)<TableContainerProps>(
  (/* { theme } */) => ({
  }),
);


export const CTableFooter = styled(TableFooter)<TableFooterProps>(
  (/* { theme } */) => ({
  }),
);


export const CTablePagination = styled(TablePagination)<TablePaginationProps>(
  (/* { theme } */) => ({
  }),
);

export const CTableSortLabel = styled(TableSortLabel)<TableSortLabelProps>(
  (/* { theme } */) => ({
  }),
);
